//export const UPLOAD_URL = "https://api.herb.apcfss.in/dms/onboarding/upload"; //for documents
//export const PRR_Docs_Pdf = "https://api.dev.herb.apcfss.in/dms/user-defined-path/file-upload/prrdocs";
//export const AUTHENTICATION_URL = "https://api.dev.nidhi.apcfss.in/login/authenticate";

const prod = {
  url: {
    // ............................PROD.........................
    HRMS_URL: "https://swapi2.dev.nidhi.apcfss.in/prtntmhrmsapi",
    UI_URL: "https://prtntm.dev.nidhi.apcfss.in",
    API_URL: "https://swapi.dev.nidhi.apcfss.in/prtntmapi/",
    API_URL_SVAMITVA: "https://swapi.dev.nidhi.apcfss.in/prtntmsvamitvaapi/",
    API_URL_SWM: "https://swapi2.dev.nidhi.apcfss.in/prtntmswmapi/",
    API_URL_MEETINGS: "https://swapi.dev.nidhi.apcfss.in/prtntmmeetingsapi/",
    PAYMENT_API_URL: "https://swapi.dev.nidhi.apcfss.in/prtntmpayment/",
    //API_URL_LOGIN: 'https://swapi.dev.nidhi.apcfss.in/svamitvaapi/data/',
    //AUTHENTICATION_URL: "https://api.dev.nidhi.apcfss.in/login/authenticate",
    AUTHENTICATION_URL:
      "https://swapi.dev.nidhi.apcfss.in/prtntmapi/grant-access",
    Fileurl:
      "https://api.swarnapanchayat.apcfss.in/panchayatrajdms/file-download/",
    QRDEVICE_ENV: "LIVE",
    SBI_PAYMENT_URL:
      "https://uatmerchant.onlinesbi.sbi/merchant/merchantprelogin.htm",
    //SBI_PAYMENT_URL:"https://merchant.onlinesbi.sbi/merchant/merchantprelogin.htm",//prod branch
    MASTERS_API_URL: "https://swapi.dev.nidhi.apcfss.in/prtntmmastersapi/",
    SBI_PAYMENT_URL: "https://uatmerchant.onlinesbi.sbi/",

    // MASTERS_API_URL: "http://localhost:8989/prtntmmastersapi/",

    CRON_API_URL: "https://swapi.dev.nidhi.apcfss.in/prtntmcron/",
  },
};

const dev = {
  url: {
    UI_URL: "http://localhost:3000",
    //  UI_URL: "https://prtntm.dev.nidhi.apcfss.in",
    //  API_URL: "https://swapi.dev.nidhi.apcfss.in/prtntmapi/",
    API_URL: "http://localhost:8080/prtntmapi/",
    AUTHENTICATION_URL: "http://localhost:8080/prtntmapi/grant-access",
    //  AUTHENTICATION_URL: "https://api.dev.nidhi.apcfss.in/login/authenticate",
    // AUTHENTICATION_URL: "https://localhost:8080/login/authenticate",
    // API_URL: "http://localhost:8080/prtntmapi/",
    API_URL_SVAMITVA: "http://localhost:8090/prtntmsvamitvaapi/",
    MASTERS_API_URL: "http://localhost:8989/prtntmmastersapi/",

    API_URL_MEETINGS: "http://localhost:9001/prtntmmeetingsapi",
    // API_URL: "http://localhost:8080/prtntmapi/",
    // PAYMENT_API_URL: "https://swapi.dev.nidhi.apcfss.in/prtntmpayment/",
    PAYMENT_API_URL: 'http://localhost:8090/prtntmpayment/',
    Fileurl:
      "https://api.swarnapanchayat.apcfss.in/panchayatrajdms/file-download/",
    QRDEVICE_ENV: "LIVE",
    SBI_PAYMENT_URL:
      "https://uatmerchant.onlinesbi.sbi/merchant/merchantprelogin.htm",

    CRON_API_URL: "http://localhost:8899/prtntmcron/",

    // HRMS_URL: "http://localhost:9091/prtntmhrmsapi",
    HRMS_URL: "https://swapi2.dev.nidhi.apcfss.in/prtntmhrmsapi",
    API_URL_SWM: "http://localhost:9092/prtntmswmapi/",
    //  API_URL_SWM: "https://swapi2.dev.nidhi.apcfss.in/prtntmswmapi/",
  },
};
export const config = process.env.NODE_ENV === "development" ? dev : prod;
